export const ThemeDefaults = Object.freeze({
	PRIMARY_COLOR: "#99CA29",
	PRIMARY_LIGHT_COLOR: "#fdfff0",
	SECONDARY_COLOR: "#21acd7",
	SECONDARY_LIGHT_COLOR: "#f0feff",
	THIRD_COLOR: "#fa8c16",
	THIRD_LIGHT_COLOR: "#fff7e6",
	CUSTOM_GREEN: "#8ac926",
	CUSTOM_LIGHT_GREEN: "#fcfff0",
	CUSTOM_RED: "#ff595e",
	CUSTOM_LIGHT_RED: "#fff2f0",
	CUSTOM_YELLOW: "#FAD717",
	CUSTOM_LIGHT_YELLOW: "#FEFBE8",
	CUSTOM_GRAY_COLOR: "#d9d9d9",
	CUSTOM_CAMPAIGN_COLOR: "#960E0E",
	GRAY_COLOR: "#9CA3AF",
	WHITE_COLOR: "#FFF",
	BLACK_COLOR: "#000",
	SATURDAY_COLOR: "#00c2ff",
	SUNDAY_COLOR: "#c40055",
});

export const THEME_COLORS = [
	"#99CA29",
	"#EA638C",
	"#DB5461",
	"#BB3E03",
	"#E85D75",
	"#C76D7E",
	"#AB92BF",
	"#8D6B94",
	"#4EA5D9",
	"#134074",
	"#005F73",
	"#8DA9C4",
	"#72A1E5",
	"#0A9396",
	"#84A07C",
	"#3C787E",
	"#77878B",
	"#9a8c98",
	"#9F8082",
	"#b5838d",
	"#6d6875",
	"#30343F",
	"#2E382E",
];
